import { render, staticRenderFns } from "./ShowContract.vue?vue&type=template&id=72ef65b8&"
import script from "./ShowContract.vue?vue&type=script&lang=js&"
export * from "./ShowContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports